import React from 'react'
import { createCombinedServerSideProps } from '../src/utils/server/page-props'
import { getLayout } from '../src/layouts/WhiteBgLayout'
import { GetServerSideProps } from 'next'
import { ConsumerPage } from '../src/model'
import { CreatePasswordVerifyPage as CreatePasswordVerifyPageEntry } from '../src/page/CreatePasswordVerify/CreatePasswordVerify'
const I18N_NAMESPACE = ['common', 'password', 'terminalError']

const CreatePasswordVerifyPage: ConsumerPage = (props) => <CreatePasswordVerifyPageEntry {...props} />

CreatePasswordVerifyPage.getLayout = getLayout({ isHideClose: true, fullscreenWhite: true })

export const getServerSideProps: GetServerSideProps = createCombinedServerSideProps(I18N_NAMESPACE)

export default CreatePasswordVerifyPage
